
import { updataStaSizeConfig } from "@/api/oms-operation-service";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import validate from "@/common/regular";
import i18n from "@/config/i18n";
@Component
export default class PiupdataSiteSize extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("siteSizeConfig.updataTitle");
  /**
   * 新增表单验证
   */
  private formItem: objAny = {
    pileMaxValue: "",
    pileMinValue: "",
    powerMaxValue: "",
    powerMinValue: ""
  };
  private validatePileMax = (rule: objAny, value: string, callback: any) => {// eslint-disable-line
    if (Number(value) < Number(this.formItem.pileMinValue)) {
      callback(
        new Error(i18n.t("siteSizeConfig.maxTips") + this.formItem.pileMinValue)
      );
    } else {
      callback();
    }
  };
  private validatePowerMax = (rule: objAny, value: string, callback: any) => {// eslint-disable-line
    if (Number(value) < Number(this.formItem.powerMinValue)) {
      callback(
        new Error(
          i18n.t("siteSizeConfig.maxTips") + this.formItem.powerMinValue
        )
      );
    } else {
      callback();
    }
  };
  private ruleInline: objAny = {
    pileMaxValue: [
      {
        required: true,
        validator: validate.int,
        name: i18n.t("siteSizeConfig.maxPile"),
        trigger: "blur"
      },
      { validator: this.validatePileMax, trigger: "blur" }
    ],
    pileMinValue: [
      {
        required: true,
        validator: validate.int,
        name: i18n.t("siteSizeConfig.minPile"), // "桩最小值",
        trigger: "blur"
      }
    ],
    powerMaxValue: [
      {
        required: true,
        validator: validate.int,
        name: i18n.t("siteSizeConfig.maxPower"), //"功率最大值",
        trigger: "blur"
      },
      { validator: this.validatePowerMax, trigger: "blur" }
    ],
    powerMinValue: [
      {
        required: true,
        validator: validate.int,
        name: i18n.t("siteSizeConfig.minPower"), //"功率最小值",
        trigger: "blur"
      }
    ]
  };

  public open(item: objAny) {
    this.formItem.pileMaxValue = item.pileMaxValue;
    this.formItem.pileMinValue = item.pileMinValue;
    this.formItem.powerMaxValue = item.powerMaxValue;
    this.formItem.powerMinValue = item.powerMinValue;
    this.modalShow = true;
    this.loading = false;
  }

  public handleSubmit(): void {
    (this.$refs["formItem"] as objAny).validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }

  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await updataStaSizeConfig(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
